import $ from 'jquery';

export default class ContactPage {
   constructor() {
      this.setEventHandlers();
      this.initContactPageForm();
      this.handleInputAttribute();
   }

   setEventHandlers() {
      // フォーム表示切り替え
      $('[name="contact-type"]', '.js-contactPageFormWrapper').on('change', (e) => {
          $('[data-form-id]').fadeOut();
          $(`[data-form-id="${e.currentTarget.value}"]`).fadeIn();
      });
  }

   // 問い合わせページ読み込み時の初期処理
   // ※mwformで確認ページ完了ページ設定をしていないため、送信後に同一ページにリダイレクトする
   // ※リダイレクト後にエラーがあれば、または完了なら、フォーム内のDOMが書き変わる
   initContactPageForm() {
      const $formWrapper = $('.js-contactPageFormWrapper');
      const $completeForm = $formWrapper.find('.mw_wp_form_complete');
      const $validatedFormFields = $formWrapper.find('.error');
      const $sendErrorForm = $formWrapper.find('.mw_wp_form_send_error');
      const $typeRadioBtns = $('[name="contact-type"]', '.js-contactPageFormWrapper');
      const initialTypeValue = $typeRadioBtns.val();

      // 3種類あるmw formを一度全部非表示
      $('[data-form-id]').hide();

      if ($completeForm.length) {
         // 送信完了後だったら
         // 種別選択を非表示＆該当フォームを表示させる
         $('.js-contactPageFormTypeSelect').hide();
         $completeForm.closest('[data-form-id]').show();
         // $formWrapper までスクロールした状態で表示させる
         $(window).scrollTop($formWrapper.offset().top - $('.js-globalNav').outerHeight());
         $('.js-formCompleteNotification').show();
      } else if ($validatedFormFields.length) {
         // バリデエラーある場合
         const $validatedFormParent = $($validatedFormFields[0]).closest('[data-form-id]');
         // 種別選択で該当フォームを選択して、該当フォームを表示させる
         $typeRadioBtns.prop('checked', false); // 一旦全部外してから↓。明示的にchangeイベントをtrigger
         $(`#contact-type-radio-${$validatedFormParent.attr('data-form-id')}`).prop('checked', true).trigger('change');
         // $formWrapper までスクロールした状態で表示させる
         $(window).scrollTop($formWrapper.offset().top - $('.js-globalNav').outerHeight());
         // errorの項目にclass付与してinputフィールドの枠線の色をerrorカラーにする
         $('.error', '.js-contactPageFormWrapper').closest('.js-form-item').addClass('hasError');
         $('.js-formErrorNotification').show();
      } else if ($sendErrorForm.length) {
         // 何らかの送信エラーがある場合
         // 種別選択を非表示＆該当フォームを表示させる
         $('.js-contactPageFormTypeSelect').hide();
         $sendErrorForm.closest('[data-form-id]').show();
         // $formWrapper までスクロールした状態で表示させる
         $(window).scrollTop($formWrapper.offset().top - $('.js-globalNav').outerHeight());
         $('.js-formSendErrorNotification').show();
      } else {
         // 通常処理では初期チェックの入っているフォームを表示させる
         $(`[data-form-id="${initialTypeValue}"]`).show();
      }
   }

   handleInputAttribute() {
      $('.js-input-required').attr('required', 'required');
      $('.js-input-type-tel').attr('type', 'tel');
   }
};
